import { render, staticRenderFns } from "./SelectModal.vue?vue&type=template&id=123b4aa6"
import script from "./SelectModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports